var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-app",
        {
          class: [
            { activeRtl: _vm.$store.state.rtl },
            _vm.$store.state.appClass
          ],
          attrs: { id: "inspire" }
        },
        [
          _vm.signupEnabled || _vm.user
            ? _c(
                "div",
                [
                  _vm.user && !_vm.isMobileLobby
                    ? _c(
                        "v-navigation-drawer",
                        {
                          staticClass: "navigation-user",
                          attrs: {
                            right: !_vm.$store.state.rtl,
                            temporary: "",
                            fixed: ""
                          },
                          model: {
                            value: _vm.$store.state.sidebar.user,
                            callback: function($$v) {
                              _vm.$set(_vm.$store.state.sidebar, "user", $$v)
                            },
                            expression: "$store.state.sidebar.user"
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { id: "userSidebar" } },
                            [
                              _vm.userSidebarState
                                ? _c("the-user-sidebar")
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  !_vm.isMobileLobby
                    ? _c(
                        "v-navigation-drawer",
                        {
                          staticClass: "navigation-menu",
                          attrs: {
                            right: _vm.$store.state.rtl,
                            temporary: "",
                            fixed: ""
                          },
                          model: {
                            value: _vm.$store.state.sidebar.main,
                            callback: function($$v) {
                              _vm.$set(_vm.$store.state.sidebar, "main", $$v)
                            },
                            expression: "$store.state.sidebar.main"
                          }
                        },
                        [
                          _vm.mainSidebarState
                            ? _c("the-main-sidebar")
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isMobileLobby
                    ? _c(
                        "v-app-bar",
                        { attrs: { app: "" } },
                        [
                          _c("v-app-bar-nav-icon", {
                            staticClass: "btn-menu",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.switchMainSidebar($event)
                              }
                            }
                          }),
                          _c("the-main-header")
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-main",
                    [
                      _c(
                        "v-container",
                        {
                          class: _vm.$route.params.slug
                            ? _vm.$route.params.slug
                            : "main",
                          attrs: { id: "cont", fluid: "" }
                        },
                        [
                          _c(
                            "transition",
                            { attrs: { name: "fade", mode: "out-in" } },
                            [_c("router-view", { staticClass: "view" })],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.isMobileLobby ? _c("game-mobile-menu") : _vm._e(),
                  !_vm.isLobby ? _c("the-footer") : _vm._e(),
                  _c("pwa-popup")
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "app-simple-login" },
                [
                  _c(
                    "v-dialog",
                    {
                      attrs: {
                        scrollable: "",
                        persistent: "",
                        "content-class": "dialog-login",
                        "max-width": "472px"
                      },
                      model: {
                        value: !_vm.$store.state.signIn.forgotPasswordDialog,
                        callback: function($$v) {
                          _vm.$set(
                            !_vm.$store.state.signIn,
                            "forgotPasswordDialog",
                            $$v
                          )
                        },
                        expression: "!$store.state.signIn.forgotPasswordDialog"
                      }
                    },
                    [_c("login", { on: { openForgot: _vm.openForgotDialog } })],
                    1
                  ),
                  _c(
                    "v-dialog",
                    {
                      attrs: {
                        scrollable: "",
                        persistent: "",
                        "content-class": "dialog-forgot",
                        "max-width": "472px"
                      },
                      model: {
                        value: _vm.$store.state.signIn.forgotPasswordDialog,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.$store.state.signIn,
                            "forgotPasswordDialog",
                            $$v
                          )
                        },
                        expression: "$store.state.signIn.forgotPasswordDialog"
                      }
                    },
                    [
                      _c("forgot-password", {
                        on: { openLogin: _vm.openLoginDialog }
                      })
                    ],
                    1
                  )
                ],
                1
              )
        ]
      ),
      _vm._l(_vm.launchedGames, function(launchedGame, index) {
        return _vm.launchedGames.length
          ? _c("game-tray", {
              key: launchedGame.alias,
              ref: "gameTrey/" + launchedGame.alias,
              refInFor: true,
              attrs: { index: index, launchedGame: launchedGame }
            })
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }